import { useLayoutEffect, useState } from 'react';
import { PR_WORKSPACE_TABS_TOOLBAR_HOST_ID } from '@home/pages/studio/pr/prHubSubTabs';

/** Tab 顶栏 portal 挂点，与 PrWorkspaceTabs 中 host 节点对应 */
export function useToolbarHost(): { toolbarHost: HTMLElement | null; inTabToolbar: boolean; } {
  const [toolbarHost, setToolbarHost] = useState<HTMLElement | null>(null);
  const inTabToolbar = Boolean(toolbarHost);

  useLayoutEffect(() => {
    if (typeof document === 'undefined') return;
    setToolbarHost(document.getElementById(PR_WORKSPACE_TABS_TOOLBAR_HOST_ID));
  }, []);

  return { toolbarHost, inTabToolbar };
}
